import React, { useEffect, useRef, useState } from "react";

const COOLDOWN_SECONDS = 5 * 60;

const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

const ResendOtp = ({ onResend }) => {
  const [secondsLeft, setSecondsLeft] = useState(COOLDOWN_SECONDS);
  const [sending, setSending] = useState(false);
  const intervalRef = useRef(null);

  const startCountdown = () => {
    setSecondsLeft(COOLDOWN_SECONDS);
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    startCountdown();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const handleClick = async () => {
    if (sending || secondsLeft > 0) return;
    setSending(true);
    try {
      await onResend();
      startCountdown();
    } finally {
      setSending(false);
    }
  };

  const canResend = secondsLeft === 0 && !sending;

  return (
    <div className="resend-otp">
      {secondsLeft > 0 ? (
        <span className="resend-otp-timer">
          Didn't receive the code? Resend in {formatTime(secondsLeft)}
        </span>
      ) : (
        <>
          Didn't receive the code?{" "}
          <span
            className={`link ${canResend ? "" : "disabled"}`}
            onClick={handleClick}
          >
            {sending ? "Sending..." : "Resend code"}
          </span>
        </>
      )}
    </div>
  );
};

export default ResendOtp;
